import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
class DocumentSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.allowedFileTypes = [];
    }
    pk() {
        return "Settings";
    }
}
DocumentSettingsResource.urlRoot = legacyApiResourceUrl("DocumentGrid");
export { DocumentSettingsResource };
//# sourceMappingURL=DocumentSettingsResource.js.map